"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _FlushStartPanelModule = _interopRequireDefault(require("../../styles/components/Flushing/FlushStartPanel.module.css"));
var _alrm = _interopRequireDefault(require("../../icons/alrm.svg"));
var _function = require("../../utils/function");
var _selectors = require("../../redux/selectors");
var _constants = require("../../utils/constants");
var _useHandleFlushDuration = _interopRequireDefault(require("../../hooks/useHandleFlushDuration"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Component for set backflush duration
 * @param {string} thingPDIDDevice
 * @param {boolean} enable
 * @return {JSX.Element}
 * @constructor
 */
const FlushStartPanel = _ref => {
  let {
    thingPDIDDevice,
    enable = true
  } = _ref;
  const [duration, setDuration] = (0, _react.useState)(_constants.defaultFlushTime);
  const listFlushData = (0, _reactRedux.useSelector)(_selectors.selectLastFlushing);
  const handleChange = (0, _react.useCallback)(e => {
    setDuration((0, _function.setValueByFieldType)(e));
  }, []);
  const {
    handleFlushDuration
  } = (0, _useHandleFlushDuration.default)({
    thingPDIDDevice
  });
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "".concat(_FlushStartPanelModule.default.bottom, " ").concat(enable ? '' : _FlushStartPanelModule.default.disabled)
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: _FlushStartPanelModule.default.input_wrap
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _alrm.default,
    alt: "Alarm"
  }), /*#__PURE__*/_react.default.createElement(_material.Input, {
    id: "input-with-sx",
    variant: "standard",
    value: duration,
    "data-type": "number",
    "data-min": 0,
    "data-max": _constants.maxFlushTime,
    onChange: e => enable && handleChange(e),
    className: _FlushStartPanelModule.default.input,
    endAdornment: /*#__PURE__*/_react.default.createElement("span", {
      className: "pt-1"
    }, "sec")
  })), /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "btn-b btn-primary br-btn px-20 ".concat(_FlushStartPanelModule.default.btn),
    onClick: () => enable && handleFlushDuration(duration)
  }, "start flush")), [duration, handleFlushDuration, listFlushData, enable]);
};
var _default = exports.default = FlushStartPanel;